export default __webpack_public_path__ + "static/media/swap-photo.656895a4.svg";